export default __webpack_public_path__ + "static/media/app_store.6da18b9a.svg";